import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { completeAmazonIntegrationOAuthAPI } from "../lib/api/api";

const AmazonIntegrationOAuth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  useEffect(() => {
    const state = searchParams.get("state");
    const sellingPartnerId = searchParams.get("selling_partner_id");
    const spapiOauthCode = searchParams.get("spapi_oauth_code");
    const error = searchParams.get("error");
    const errorDescription = searchParams.get("error_description");

    if (error) {
      toast.error(
        errorDescription ||
          "Seller Central-Verknüpfung konnte nicht abgeschlossen werden."
      );
      navigate("/settings", { replace: true });
      return;
    }

    if (!state || !sellingPartnerId || !spapiOauthCode) {
      toast.error(
        "Erforderliche Amazon-Parameter fehlen. Bitte starte die Verknüpfung erneut."
      );
      navigate("/settings", { replace: true });
      return;
    }

    const finalizeIntegration = async () => {
      try {
        const response = await completeAmazonIntegrationOAuthAPI({
          state,
          sellingPartnerId,
          spapiOauthCode,
        });
        const status = String(response?.status || "").toLowerCase();

        if (status === "success" || status === "authorized") {
          toast.success("Seller Central erfolgreich verknüpft.");
        } else if (status === "unauthorized") {
          toast.error(
            response?.message ||
              "Die Seller Central-Verknüpfung wurde abgelehnt. Bitte versuche es erneut."
          );
        } else if (response?.message) {
          toast.info(response.message);
        } else {
          toast.success("Seller Central-Integration aktualisiert.");
        }

        queryClient.invalidateQueries(["settings", "subscription"]);
      } catch {
        // Fehler wurde bereits im API-Layer getoastet.
      } finally {
        navigate("/settings", { replace: true });
      }
    };

    finalizeIntegration();
  }, [searchParams, navigate, queryClient]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bgColor px-4 py-8 text-textTitle">
      <div className="flex flex-col items-center gap-3 rounded-lg border border-borderBottom bg-background px-6 py-8 shadow-sm">
        <i className="bx bx-loader-alt animate-spin text-4xl text-primary"></i>
        <h1 className="text-lg font-semibold">
          Seller Central wird verbunden …
        </h1>
        <p className="text-center text-sm text-textPrimary">
          Bitte warte einen Moment. Du wirst gleich zu den Einstellungen
          weitergeleitet.
        </p>
      </div>
    </div>
  );
};

export default AmazonIntegrationOAuth;
